import React from 'react';
import {
    ElementsConsumer, CardElement,
    CardNumberElement,
    CardExpiryElement,
    CardCvcElement,
} from '@stripe/react-stripe-js';
import ControlService from '../../../controlservice';
import { toast } from 'react-toastify';
import Message from '../../Message';
import { RefreshComponentOnClose } from '../../../../forms/Button/_private';

const options = {
    style: {
        base: {
            padding: '7px 12px',
            fontSize: '16px',
            color: '#343a40',
            minHeight: '21px',
            letterSpacing: '0.025em',
            fontFamily: 'Source Code Pro, monospace',
            '::placeholder': {
                color: '#aab7c4',
            },
        },
        invalid: {
            color: '#9e2146',
        },
    },
};

class CheckoutForm extends React.Component {
    constructor() {
        super();
        this.state = {
            elementFontSize: window.innerWidth < 450 ? '14px' : '18px',
        };
        window.addEventListener('resize', () => {
            if (window.innerWidth < 450 && this.state.elementFontSize !== '14px') {
                this.setState({ elementFontSize: '14px' });
            } else if (
                window.innerWidth >= 450 &&
                this.state.elementFontSize !== '18px'
            ) {
                this.setState({ elementFontSize: '18px' });
            }
        });
    }
    handleSubmit = async (event) => {
        // We don't want to let default form submission happen here,
        // which would refresh the page.
        event.preventDefault();
        debugger;
        const { control, formid, stripe, elements } = this.props;
        let data = this.props.data[formid] ? this.props.data[formid] : {};
        if (!stripe || !elements) {
            // Stripe.js has not yet loaded.
            // Make sure to disable form submission until Stripe.js has loaded.
            return;
        }
        this.props.dataIsLoading(true);
        const result = await stripe.createToken(
            control.paymentformtype === 'split' ?
                elements.getElement(CardNumberElement)
                : elements.getElement(CardElement)
        );

        if (result.error) {
            this.props.dataIsLoading(false);

            // Show error to your customer (e.g., payment details incomplete)
            toast.error(<Message icon={control.errormsgicon} message={result.error.message} type="error" />)
            console.log(result.error.message);
        } else {
            this.savePaymentResponse(control, data, result.token);
        }
    };
    savePaymentResponse(control, data, result) {
        try {
            var apiparam = {};
            debugger;
            let dataModel = { ...data, stripe_res: result };
            let url = control.Api;
            control.apiparam = control.paramlist;

            control.paramlist.forEach(option => {
                apiparam[option.key] = option.value;
            })
            ControlService().ServiceRequest(url, apiparam, control, this.props.token, JSON.stringify(dataModel), null, null, null, this.props)
                .then(res => {
                    debugger;
                    if (res && res.status != "error" && (res.statusCode == 201 || res.statusCode == 200 || !res.statusCode)) {
                        res.status = "success";
                    } else {
                        res.status = "error";
                    }
                    this.props.dataIsLoading(false);

                    if (res.status == "success") {
                        if (control.attachwithformwizard) {
                            this.props.update(control.formwizardkey + '_next', uuidv4(), control.formwizardcomponentformid ? (control.formwizardcomponentformid + 'write') : this.props.formid);
                        }
                        RefreshComponentOnClose(control, this.props.formid, this.props);
                        if (control.successmsgtitle) {
                            toast.success(<Message icon={control.successmsgicon} title={control.successmsgtitle} message={control.successmsgtext} type="success" />)
                        } else if (res.message) {
                            toast.success(<Message message={res.message ? res.message : null} type="success" />)
                        }

                    } else if (res.status == "error") {
                        if (control.errormsgtitle) {
                            toast.error(<Message icon={control.errormsgicon} title={control.errormsgtitle} message={control.errormsgtext} type="error" />)
                        } else {
                            toast.error(<Message icon={control.errormsgicon} message={res.message} type="error" />)
                        }
                    } else {
                        toast.error(<Message icon={control.errormsgicon} message={res.message} type="error" />);
                    }
                })
                .catch(err => {
                    this.props.dataIsLoading(false);
                    console.log(err.message);
                });
        } catch {
            this.props.dataIsLoading(false);

        }
    }
    render() {
        const { control, data } = this.props;
        var customStyle = {};
        if (control.styles) {
            try {
                customStyle = JSON.parse(control.styles);
            } catch {
                customStyle = {};
            }
        }
        return (
            <form onSubmit={this.handleSubmit}>
                {control.paymentformtype === 'split' ?
                    <div className='row'>
                        <div className={"form-group col-md-" + (control.CardNumberWidth ? control.CardNumberWidth : '12')}>
                            <label>Card number</label>
                            <CardNumberElement className="form-control" options={options} />
                        </div>
                        <div className={"form-group col-md-" + (control.CardExpiryWidth ? control.CardExpiryWidth : 'auto')}>
                            <label>Expiration date</label>
                            <CardExpiryElement className="form-control" options={options} />
                        </div>
                        <div className={"form-group col-md-" + (control.CardCvcWidth ? control.CardCvcWidth : '1')} style={{ minWidth: 82 }}>
                            <label>CVC</label>
                            <CardCvcElement className="form-control" options={options} />
                        </div>
                    </div>
                    :
                    <div className="form-group">
                        <CardElement className="form-control"
                            options={options} />
                    </div>
                }
                <button disabled={!this.props.stripe} data-tip data-for={control.id}
                    className={'mb-3 btn ' + control.coutomClass + ' btn-' + control.buttontype + ' btn-' + control.size}
                    style={customStyle}
                >
                    {control.WebIcon &&
                        <i className={control.WebIcon + (control.label ? ' mr-2' : '')}></i>
                    }
                    {control.bindbuttonlabelwithdata ? data[control.key] : control.label}

                </button>
            </form >
        );
    }
}

export default function InjectedCheckoutForm(props) {
    return (
        <ElementsConsumer>
            {({ stripe, elements }) => (
                <CheckoutForm {...props} stripe={stripe} elements={elements} />
            )}
        </ElementsConsumer>
    )
}